import React from 'react'
import { subscribe } from 'react-contextual'
import { SearchFilter } from '../../../views/components'
import SuspenseAccountsProvider from '../SuspenseAccountsProvider'

const SuspenseAccountsSearchFilter = (props: any) => <SearchFilter {...props} />

export default subscribe([SuspenseAccountsProvider], ({ location, redirect, filters }: any) => ({
  pathname: location.pathname,
  redirect,
  filters,
}))(SuspenseAccountsSearchFilter)
